import { ApiModule } from '~/clientApi/ApiModule';

const insights = (apiInstance) => new ApiModule(apiInstance, 'insights');

export default insights;
